import React from 'react'

import { BellIcon } from 'icons/BellIcon/BellIconV2'
import { ApiKeysIcon } from 'icons/MyAccountIcons/MyAccountIcons'
import { SettingsIcon } from 'icons/SettingsIcon/SettingsIconV2'

import { Icon } from '@junglescout/edna'

import {
  ADVERTISING_URLS,
  INVENTORY_URLS,
  KEYWORD_LISTS_URL,
  KEYWORD_SCOUT_URL,
  LAUNCH_BASE_URLS,
  LISTING_BUILDER_BASE,
  LISTING_GRADER_BASE,
  MARKET_INSIGHTS_URLS,
  PRODUCT_INSIGHTS_URL,
  PRODUCT_RESEARCH_URLS,
  PRODUCT_COSTS_URL,
  PRODUCTS_URL,
  RANK_TRACKER_BASE,
  SALES_ANALYTICS_URLS,
  SALES_ESTIMATOR_URL,
  SHARE_OF_VOICE_URL,
  PAGE_NAMES
} from 'constants/routes'

export const SIDEBAR_SEARCH_RESULTS = t => {
  const pageNames = PAGE_NAMES(t)
  return [
    {
      title: pageNames.marketInsights,
      description: t(
        'global_search:description.marketInsights',
        'Manage your segments'
      ),
      keywords: [
        t('generic:Edit', 'Edit'),
        t('generic:Delete', 'Delete'),
        t('generic:Pause', 'Pause')
      ],
      url: MARKET_INSIGHTS_URLS.segmentManager,
      icon: <Icon name="NAV_MARKET_INSIGHT" />,
      canAccess: () => true,
      withinLimits: () => true
    },
    {
      title: pageNames.shareAndTrends,
      description: t(
        'global_search:description.shareAndTrends',
        'Understand your market share'
      ),
      keywords: [],
      url: MARKET_INSIGHTS_URLS.shareAndTrendsBase,
      icon: <Icon name="NAV_MARKET_INSIGHT" />,
      canAccess: () => true,
      withinLimits: () => true
    },
    {
      title: pageNames.productInsights,
      description: t(
        'global_search:description.productInsights',
        'Look up and track products to get insights'
      ),
      keywords: [t('global_search:keywords.productTracked', 'Product Tracked')],
      url: PRODUCT_INSIGHTS_URL,
      icon: <Icon name="NAV_PROD_INSIGHTS" />,
      canAccess: () => true,
      withinLimits: () => true
    },
    {
      title: pageNames.shareOfVoice,
      description: t(
        'global_search:description.shareOfVoice',
        'Look up new products'
      ),
      keywords: [t('generic:Keywords', 'Keywords')],
      url: SHARE_OF_VOICE_URL,
      icon: <Icon name="NAV_SHARE_VOICE" />,
      canAccess: () => true,
      withinLimits: () => true
    },
    {
      title: pageNames.salesEstimator,
      description: t(
        'global_search:description.salesEstimator',
        'Average monthly sales numbers for specific Amazon categories'
      ),
      keywords: [],
      url: SALES_ESTIMATOR_URL,
      icon: <Icon name="NAV_TOOLBOX" />,
      canAccess: () => true,
      withinLimits: () => true
    },
    {
      title: pageNames.listingGrader,
      description: t(
        'global_search:description.listingGrader',
        'Listing Optimization Score'
      ),
      keywords: [],
      url: LISTING_GRADER_BASE,
      icon: <Icon name="NAV_TOOLBOX" />,
      canAccess: () => true,
      withinLimits: () => true
    },
    {
      title: pageNames.db,
      description: t('global_search:description.db', 'Search for products'),
      keywords: [],
      url: PRODUCT_RESEARCH_URLS.database,
      icon: <Icon name="NAV_PROD_RESEARCH" />,
      canAccess: () => true,
      withinLimits: () => true
    },
    {
      title: pageNames.opFinder,
      description: t(
        'global_search:description.opFinder',
        'Find niches with high demand and low competition.'
      ),
      keywords: [t('constants:keyword.KEYWORD_TABLE_COLUMNS.name', 'Niche')],
      url: PRODUCT_RESEARCH_URLS.opportunityFinder,
      icon: <Icon name="NAV_PROD_RESEARCH" />,
      canAccess: () => true,
      withinLimits: () => true
    },
    {
      title: pageNames.keywordScout,
      description: t(
        'global_search:description.keywordScout',
        'Track down applicable search information for keywords or asins'
      ),
      keywords: [],
      url: KEYWORD_SCOUT_URL,
      icon: <Icon name="NAV_KEYWORDS" />,
      path: null,
      canAccess: () => true,
      withinLimits: () => true
    },
    {
      title: pageNames.keywordList,
      description: t(
        'global_search:description.keywordList',
        'Create your keyword list'
      ),
      keywords: [],
      url: KEYWORD_LISTS_URL,
      icon: <Icon name="NAV_KEYWORDS" />,
      canAccess: () => true,
      withinLimits: () => true
    },
    {
      title: pageNames.listingBuilder,
      description: t(
        'global_search:description.listingBuilder',
        'Product listings based on the top keywords from your search'
      ),
      keywords: [],
      url: LISTING_BUILDER_BASE,
      icon: <Icon name="NAV_KEYWORDS" />,
      path: null,
      canAccess: () => true,
      withinLimits: () => true
    },
    {
      title: pageNames.rankTracker,
      description: t(
        'global_search:description.rankTracker',
        'Track how you or your competitor rank for your keywords'
      ),
      keywords: [],
      url: RANK_TRACKER_BASE,
      icon: <Icon name="NAV_KEYWORDS" />,
      canAccess: () => true,
      withinLimits: () => true
    },
    {
      title: pageNames.reviewAutomation,
      description: t(
        'global_search:description.reviewAutomation',
        'Automate asking customers for reviews'
      ),
      keywords: [],
      url: LAUNCH_BASE_URLS.reviewAutomation,
      icon: <Icon name="NAV_MARKETING" />,
      canAccess: () => true,
      withinLimits: () => true
    },

    {
      title: pageNames.profit,
      description: t(
        'global_search:description.profit',
        'View sales and profit data over time'
      ),
      keywords: [],
      url: SALES_ANALYTICS_URLS.profitOverview,
      icon: <Icon name="NAV_SALES_ANALYTICS" />,
      canAccess: () => true,
      withinLimits: () => true
    },
    {
      title: pageNames.profitAndLoss,
      description: t(
        'global_search:description.profitAndLoss',
        'Detailed Profit & Loss statement'
      ),
      keywords: [],
      url: SALES_ANALYTICS_URLS.profitAndLoss,
      icon: <Icon name="NAV_SALES_ANALYTICS" />,
      canAccess: () => true,
      withinLimits: () => true
    },
    {
      title: pageNames.expenses,
      description: t(
        'global_search:description.expenses',
        'Customize entries for revenue and expenses'
      ),
      keywords: [],
      url: SALES_ANALYTICS_URLS.expenses,
      icon: <Icon name="NAV_SALES_ANALYTICS" />,
      canAccess: () => true,
      withinLimits: () => true
    },
    {
      title: pageNames.adsAnalytics,
      description: t(
        'global_search:description.adsAnalytics',
        'Learn how your advertising activities impact your sales and bottom line'
      ),
      keywords: [],
      url: ADVERTISING_URLS.analytics,
      icon: <Icon name="NAV_ADS" />,
      canAccess: () => true,
      withinLimits: () => true
    },

    {
      title: pageNames.inventory,
      description: t(
        'global_search:description.inventory',
        'Accurately predict how much stock you will need and when to order it'
      ),
      keywords: [],
      url: INVENTORY_URLS.inventoryForecast,
      icon: <Icon name="NAV_MANAGE_PROD" />,
      canAccess: () => true,
      withinLimits: () => true
    },
    {
      title: pageNames.prodSettings,
      description: t(
        'global_search:description.prodSetting',
        'View up-to-date information on your products'
      ),
      keywords: [],
      url: PRODUCTS_URL,
      icon: <Icon name="NAV_MANAGE_PROD" />,
      canAccess: () => true,
      withinLimits: () => true
    },
    {
      title: pageNames.costs,
      description: t(
        'global_search:description.costs',
        'Get a comprehensive overview of your Product Costs'
      ),
      keywords: [],
      url: PRODUCT_COSTS_URL,
      icon: <Icon name="NAV_MANAGE_PROD" />,
      canAccess: () => true,
      withinLimits: () => true
    }
  ]
}

export const STATIC_SEARCH_RESULTS = t => {
  return [
    {
      title: t('global_search:title.createSegment', 'Create New Segment'),
      description: t(
        'global_search:description.buildSegment',
        'Build a new segment'
      ),
      keywords: [],
      url: '/market-insights/segments/new/search',
      icon: <Icon name="NAV_MARKET_INSIGHT" />,
      canAccess: globalData =>
        globalData?.featureAccess.cobalt?.segmentBuilder === true,
      withinLimits: () => true
    },
    {
      title: t('global_search:title.accountInfo', 'Account Info'),
      description: t(
        'global_search:description.accountInfo',
        'Manage your account and permissions'
      ),
      keywords: [
        t('global_search:keywords.profile', 'profile'),
        t('global_search:keywords.email', 'email')
      ],
      url: '/account/info',
      icon: SettingsIcon,
      type: 'setting',
      canAccess: () => true,
      withinLimits: () => true
    },
    {
      title: t('global_search:title.emailSetting', 'Email Settings'),
      description: t(
        'global_search:description.emailSetting',
        'Manage email notifications'
      ),
      keywords: [],
      url: '/account/email-settings',
      icon: SettingsIcon,
      type: 'setting',
      canAccess: () => true,
      withinLimits: () => true
    },
    {
      title: t('global_search:title.alertSettings', 'Alert Settings'),
      description: t(
        'global_search:description.alertSetting',
        'Manage how you get alerted when a product changes'
      ),
      keywords: [],
      url: '/account/alert-settings',
      icon: BellIcon,
      canAccess: () => true,
      withinLimits: () => true
    },
    {
      title: t('global_search:title.amazonSetting', 'Amazon Settings'),
      description: t(
        'global_search:description.amazonSetting',
        'Manage your Amazon Seller Central account information'
      ),
      keywords: [
        t('global_search:keywords.aws', 'aws'),
        t('global_search:keywords.key', 'key')
      ],
      url: '/account/amazon-settings',
      icon: SettingsIcon,
      type: 'setting',
      canAccess: globalData => globalData?.membershipInfo.admin === true,
      withinLimits: () => true
    },
    {
      title: t(
        'global_search:title.userAndTeamManagement',
        'User & Team Management'
      ),
      description: t(
        'global_search:description.userAndTeamManagement',
        'Manage your user and team accounts'
      ),
      keywords: [
        'team',
        t('global_search:keywords.settings', 'settings'),
        t('global_search:keywords.invite', 'invite')
      ],
      url: '/account/team-settings?tab=users',
      icon: SettingsIcon,
      type: 'setting',
      canAccess: globalData => globalData?.membershipInfo.admin === true,
      withinLimits: () => true
    },
    {
      title: t('global_search:title.alerts', 'Alerts'),
      description: t('global_search:description.alerts', 'See all alerts'),
      keywords: [],
      url: '/alerts',
      icon: BellIcon,
      canAccess: () => true,
      withinLimits: () => true
    },
    {
      title: t('global_search:title.api', 'API'),
      description: t('global_search:description.api', 'Manage your API Key'),
      keywords: [t('global_search:keywords.key', 'key')],
      url: '/account/api-keys',
      icon: ApiKeysIcon,
      canAccess: globalData => globalData?.user.has_public_api_access === true,
      withinLimits: () => true
    },
    {
      title: t('global_search:title.languages', 'Languages'),
      description: t(
        'global_search:description.languages',
        'Change the language that is displayed throughout the app'
      ),
      keywords: [t('global_search:keywords.key', 'key')],
      url: '/account/languages',
      icon: SettingsIcon,
      type: 'setting',
      canAccess: () => true,
      withinLimits: () => true
    },
    {
      title: t('global_search:title.cobaltSupport', 'Cobalt Support'),
      description: t(
        'global_search:description.cobaltSupport',
        'Cobalt Support Center'
      ),
      keywords: [t('global_search:keywords.help', 'help')],
      url: 'https://cobaltjs.zendesk.com/hc/en-us',
      canAccess: () => true,
      withinLimits: () => true
    },
    {
      title: t('global_search:title.ticket', 'Create a Support Ticket'),
      description: t(
        'global_search:description.ticket',
        'Submit a support ticket'
      ),
      keywords: [
        t('global_search:keywords.help', 'help'),
        t('global_search:keywords.bug', 'bug')
      ],
      url: 'https://cobaltjs.zendesk.com/hc/en-us/requests/new',
      canAccess: () => true,
      withinLimits: () => true
    },
    {
      title: t('global_search:title.faq', 'Cobalt FAQ'),
      description: t(
        'global_search:description.faq',
        'Frequently Asked Questions'
      ),
      keywords: [
        t('global_search:keywords.help', 'help'),
        t('global_search:keywords.doc', 'doc'),
        t('global_search:keywords.howTo', 'how to')
      ],
      url:
        'https://cobaltjs.zendesk.com/hc/en-us/articles/4586536369943-Cobalt-FAQs',
      canAccess: () => true,
      withinLimits: () => true
    },
    {
      title: t(
        'global_search:title.gettingStarted',
        'Cobalt - Getting Started'
      ),
      description: t(
        'global_search:description.gettingStarted',
        'Documentation on getting started with Cobalt'
      ),
      keywords: [
        t('global_search:keywords.help', 'help'),
        t('global_search:keywords.doc', 'doc')
      ],
      url:
        'https://cobaltjs.zendesk.com/hc/en-us/categories/5077287185559-Getting-Started',
      canAccess: () => true,
      withinLimits: () => true
    }
  ]
}
